(() => {
  window.addEventListener("load", () => {
    setTimeout(() => {
      document.querySelectorAll("[data-option-subsave], [data-option-onetime]").forEach((el) => {
        el.addEventListener("click", () => {
          el.querySelector("input").click();
        });
      });
    }, 1000);
  });
})();
